import React, { useCallback, useState } from 'react';
import { defineMessages } from 'react-intl';
import { companyName } from '@constants';
import useAuth from '@hooks/useAuth';
import useTranslate from '@hooks/useTranslate';
import { Layout } from 'antd';

import AppHeader from './AppHeader';
import NavSider from './NavSider';
import NavSiderTenant from './NavSiderTenant';

import styles from './MainLayout.module.scss';

const { Content, Footer } = Layout;

const SIDEBAR_WIDTH_EXPAND = 264;

const message = defineMessages({
    copyRight: '© {year} <strong>{companyName}</strong>. All rights reserved.',
});

const MainLayout = ({ children }) => {
    const [ collapsed, setCollapsed ] = useState(false);
    const translate = useTranslate();
    const toggleCollapsed = () => setCollapsed((prev) => !prev);
    const { isAdmin } = useAuth();

    const Sider = isAdmin() ? NavSider : NavSiderTenant;
    return (
        <Layout hasSider>
            <Sider collapsed={collapsed} onCollapse={toggleCollapsed} width={SIDEBAR_WIDTH_EXPAND} />
            <Layout>
                <AppHeader collapsed={collapsed} onCollapse={toggleCollapsed} />
                <Content className={styles.appContent}>
                    <div className={styles.wrapper}>{children}</div>
                    <Footer className={styles.appFooter}>
                        {translate.formatMessage(message.copyRight, {
                            strong: (chunk) => <strong>{chunk}</strong>,
                            companyName,
                            year: new Date().getFullYear(),
                        })}
                    </Footer>
                </Content>
            </Layout>
        </Layout>
    );
};

export default MainLayout;
